var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCostEffectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 2,
    fill: "#D75F04"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3592 74.7778H67.6378M60.5 32V35.0556M79.9456 40.0544L77.7853 42.2147M88 59.5H84.9444M36.0556 59.5H33M43.2147 42.2147L41.0544 40.0544M49.6956 70.3044C47.5593 68.1676 46.1047 65.4454 45.5155 62.4819C44.9263 59.5184 45.2291 56.4468 46.3856 53.6554C47.542 50.864 49.5002 48.4781 52.0125 46.7996C54.5249 45.121 57.4785 44.2251 60.5 44.2251C63.5215 44.2251 66.4751 45.121 68.9875 46.7996C71.4998 48.4781 73.458 50.864 74.6144 53.6554C75.7709 56.4468 76.0737 59.5184 75.4845 62.4819C74.8953 65.4454 73.4407 68.1676 71.3044 70.3044L69.63 71.9758C68.6727 72.9333 67.9134 74.0699 67.3954 75.3208C66.8774 76.5718 66.6109 77.9125 66.6111 79.2664V80.8889C66.6111 82.5097 65.9673 84.064 64.8212 85.2101C63.6752 86.3562 62.1208 87 60.5 87C58.8792 87 57.3248 86.3562 56.1788 85.2101C55.0327 84.064 54.3889 82.5097 54.3889 80.8889V79.2664C54.3889 76.5317 53.3011 73.9069 51.37 71.9758L49.6956 70.3044Z",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostEffectionIcon);
export default __webpack_public_path__ + "static/media/cost-effection-icon.bdb4b4e50be83989a236c5f7eda19ea3.svg";
export { ForwardRef as ReactComponent };